function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import ScrollBar from 'react-scrollbars-custom';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import Button from '../Button';
import { ArrowLeftIcon, CheckIcon } from '../../icon';
import { check } from '../../styles/wizard';
import styles, { list } from './Wizard.style';
import useMediaQuery from '../../hooks/use-media-query';
import { mediaQuery } from '../../utils';
import { LanguageSelectorVertical } from '../LanguageSelector';
const WizardContext = /*#__PURE__*/React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'idle':
      {
        return { ...state,
          status: 'idle'
        };
      }

    case 'next':
      {
        const {
          currentIndex,
          currentPercentage,
          percentageToIncrease,
          steps
        } = state;

        if (currentIndex < steps.length - 1) {
          const newSteps = [...steps];
          const newStepIndex = currentIndex + 1;
          newSteps[currentIndex] = { ...newSteps[currentIndex],
            valid: true,
            status: 'finished'
          };
          newSteps[newStepIndex] = { ...newSteps[newStepIndex],
            status: 'current'
          };
          return { ...state,
            steps: newSteps,
            currentIndex: newStepIndex,
            currentStepCode: steps[newStepIndex].code,
            currentPercentage: currentPercentage + percentageToIncrease,
            action: 'next',
            status: 'navigate'
          };
        }

        return state;
      }

    case 'updateSteps':
      {
        return { ...state,
          steps: action.steps
        };
      }

    case 'inValidateSteps':
      {
        return { ...state,
          steps: state.steps.map(step => {
            if (step.order < state.currentIndex) {
              return { ...step,
                valid: false
              };
            }

            return step;
          })
        };
      }

    case 'beforeFinish':
      {
        const {
          currentIndex,
          steps
        } = state;
        const newSteps = [...steps];
        newSteps[currentIndex] = { ...newSteps[currentIndex],
          status: 'beforeFinished'
        };
        return { ...state,
          steps: newSteps,
          action: 'next',
          status: 'navigate'
        };
      }

    case 'back':
      {
        const {
          currentIndex,
          currentPercentage,
          percentageToIncrease,
          steps
        } = state;

        if (currentIndex > 0) {
          const newSteps = [...steps];
          const newStepIndex = currentIndex - 1;
          newSteps[currentIndex] = { ...newSteps[currentIndex],
            status: 'inactive'
          };
          newSteps[newStepIndex] = { ...newSteps[newStepIndex],
            status: 'current'
          };
          return { ...state,
            steps: newSteps,
            currentIndex: newStepIndex,
            currentStepCode: steps[newStepIndex].code,
            currentPercentage: currentPercentage - percentageToIncrease,
            action: 'back',
            status: 'navigate'
          };
        }

        return state;
      }

    case 'go':
      {
        const {
          percentageToIncrease,
          steps
        } = state;
        const newSteps = [...steps];
        const newStepIndex = action.index;
        newSteps.filter((step, index) => index < newStepIndex).forEach(step => {
          newSteps[step.id] = { ...step,
            status: 'finished'
          };
        });
        newSteps.filter((step, index) => index > newStepIndex).forEach(step => {
          newSteps[step.id] = { ...step,
            status: 'inactive'
          };
        });
        newSteps[newStepIndex] = { ...newSteps[newStepIndex],
          status: 'current'
        };
        const newPercentage = newStepIndex * percentageToIncrease;
        return { ...state,
          steps: newSteps,
          currentIndex: newStepIndex,
          currentStepCode: steps[newStepIndex].code,
          currentPercentage: newPercentage,
          action: 'go',
          status: 'navigate'
        };
      }

    case 'saveAndNavigate':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'executingPromise'
        };
      }

    case 'saveAndExit':
      {
        return { ...state,
          action: 'saveAndExit',
          status: 'executingPromise'
        };
      }

    case 'saveAndExitModal':
      {
        return { ...state,
          action: 'saveAndExitModal',
          isSaveAndExitModalVisible: action.visible
        };
      }

    case 'showModal':
      {
        return { ...state,
          action: 'showModal',
          status: 'executingPromise'
        };
      }

    case 'hideModal':
      {
        return { ...state,
          action: 'hideModal',
          status: 'executingPromise'
        };
      }

    case 'sendProcedureForReview':
      {
        return { ...state,
          action: 'sendingProcedureForReview',
          status: 'isPendingSendProcedureForReview'
        };
      }

    case 'saveAndNavigatePending':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'isPendingSaveAndNavigate'
        };
      }

    case 'saveAndNavigateResolved':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'isResolvedSaveAndNavigate'
        };
      }

    case 'save':
      {
        return { ...state,
          action: 'save',
          status: 'executingPromise'
        };
      }

    case 'savePending':
      {
        return { ...state,
          action: 'save',
          status: 'isPendingSave'
        };
      }

    case 'saveResolved':
      {
        return { ...state,
          action: 'save',
          status: 'isResolvedSave'
        };
      }

    case 'nextButtonStatus':
      {
        return { ...state,
          isNextButtonDisabled: action.disabled
        };
      }

    case 'onNextClick':
      {
        return { ...state,
          onNextClick: action.onNextClick
        };
      }

    case 'onBackClick':
      {
        return { ...state,
          onBackClick: action.onBackClick
        };
      }

    case 'onGo':
      {
        return { ...state,
          onGo: action.onGo
        };
      }

    case 'onCloseClick':
      {
        return { ...state,
          onCloseClick: action.onCloseClick
        };
      }

    default:
      throw new Error(`unexpected action type ${action.type}`);
  }
};

function useWizard() {
  const context = React.useContext(WizardContext);

  if (context === undefined) {
    throw new Error('useWizard debe ser usado dentro de WizardProvider');
  }

  return context;
}
/**
 * This hook is used to navigate on the wizard
 * @param {string} step Wizard step.
 * @param {function} onTry Function triggered by the try.
 * @param {function} onCatch Function triggered by the catch.
 */


function useWizardMainNavigation({
  step,
  onTry,
  onCatch
}) {
  const {
    action,
    currentStepCode,
    status,
    dispatch
  } = useWizard();
  const history = useHistory();
  React.useEffect(() => {
    async function wizardDidUpdate() {
      if (['saveAndNavigate', 'saveAndExit'].includes(action) && status === 'executingPromise' && currentStepCode === step) {
        try {
          if (onTry && typeof onTry === 'function') {
            await onTry();
          }

          if (action === 'saveAndExit') {
            history.push('/');
            return;
          }

          dispatch({
            type: 'next'
          });
        } catch (error) {
          if (onCatch && typeof onCatch === 'function') {
            await onCatch(error);
          }

          if (action === 'saveAndExit') {
            dispatch({
              type: 'saveAndExitModal',
              visible: false
            });
          }

          console.error(error);
        } finally {
          dispatch({
            type: 'idle'
          });
        }
      }
    }

    wizardDidUpdate();
  }, [action, currentStepCode, status]);
}
/**
 * This component represent the StepsSideBarHead
 * @param {string} title Wizard head title.
 * @param {string} subtitle Wizard head subtitle
 */


const StepsSideBarHead = /*#__PURE__*/React.memo(({
  title,
  subtitle
}) => {
  return jsx(React.Fragment, null, jsx("span", {
    style: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: '0.01em',
      color: '#0883a0',
      textTransform: 'uppercase'
    }
  }, subtitle), jsx("h1", {
    style: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 30,
      lineHeight: '41px',
      color: '#2b2d42',
      marginTop: 0
    }
  }, title));
});
/**
 * This component represent the Step Side Bar circle
 * @param {string} status Step status (current, finished, beforeFinished)
 */

const StepsSideBarListItemCircle = /*#__PURE__*/React.memo(({
  status
}) => {
  const className = classNames('sidebar-list-item-circle', {
    current: status === 'current',
    finished: status === 'finished' || status === 'beforeFinished'
  });
  return jsx("div", {
    className: className
  }, status === 'finished' || status === 'beforeFinished' ? jsx(CheckIcon, {
    css: check
  }) : null);
});
/**
 * This component represent the Step Side Bar item name
 * @param {string} status Step status.
 * @param {*} children Item content.
 */

const StepsSideBarListItemName = /*#__PURE__*/React.memo(({
  children,
  status
}) => {
  return jsx("div", {
    style: {
      lineHeight: '30px',
      marginLeft: 24,
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 17,
      letterSpacing: '0.01em',
      color: status === 'inactive' ? '#08415C' : '#CE1625'
    }
  }, children);
});
/**
 * This component represent the Step Side Bar item
 * @param {*} children Item name.
 * @param {string} status Step status.
 * @param {function} onGo Function to navigate to.
 * @param {string} step Wizard step .
 */

const StepsSideBarListItem = /*#__PURE__*/React.memo(({
  children,
  listItemStyle,
  onGo,
  step
}) => {
  let props = {};
  const classnames = classNames('sidebar-list-item', {
    pointer: step.valid,
    disabled: !step.valid
  });

  if (step.valid) {
    props = {
      onClick: () => onGo(step.id),
      role: 'menuitem',
      tabIndex: 0
    };
  }

  return jsx("li", _extends({
    className: classnames,
    style: { ...listItemStyle
    }
  }, props), children);
});
/**
 * This component represent the Step Side Bar list
 * @param {JSON} listItemStyle Custom style for the  StepsSideBarListItem component.
 * @param {object} state Side bar list actual state.
 */

const StepsSideBarList = /*#__PURE__*/React.memo(({
  listItemStyle,
  state
}) => {
  return jsx("ul", {
    css: list(state.currentPercentage)
  }, state.steps.map(step => jsx(StepsSideBarListItem, {
    key: step.id,
    listItemStyle: listItemStyle,
    onGo: state.onGo,
    step: step
  }, jsx(StepsSideBarListItemCircle, {
    status: step.status
  }), jsx(StepsSideBarListItemName, {
    status: step.status
  }, step.name))));
}, (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps));
/**
 * This component represent the Step Side Bar container for the side bar list.
 * @param {*} children Content of the side bar.
 * @param {JSON} containerStyle Custom style for the  container.
 */

const StepsSideBarContainer = /*#__PURE__*/React.memo(function StepsSideBarContainer({
  children,
  containerStyle
}) {
  return jsx("div", {
    className: "sidebar-container no-print",
    style: { ...containerStyle
    }
  }, children);
});
/**
 * This component represents the Mobile Navigation header that is render only when the screen is in mobile size.
 * @param {JSON} procedure Procedure information.
 * @param {boolean} showLanguageSelector Used to display the language selector.
 */

function MobileNavigationHeader({
  name: procedure,
  showLanguageSelector
}) {
  var _steps;

  const {
    dispatch,
    steps,
    currentIndex
  } = useWizard();
  const {
    id,
    name
  } = steps[currentIndex];
  const handlerBack = React.useCallback(() => {
    dispatch({
      type: 'back'
    });
  });
  const isPreviousStepValid = (_steps = steps[currentIndex - 1]) === null || _steps === void 0 ? void 0 : _steps.valid;
  return jsx("div", {
    css: {
      display: 'none',
      height: 108,
      boxSizing: 'border-box',
      position: 'sticky',
      top: 0,
      backgroundColor: '#fff',
      width: '100%',
      zIndex: 2,
      background: 'linear-gradient(to right, #EBF1F4 74px, #fff 0%)',
      '@supports (padding-top: constant(safe-area-inset-top))': {
        '--safe-area-inset-top': 'constant(safe-area-inset-top)',
        paddingTop: 'var(--safe-area-inset-top)',
        height: 'calc(108px + var(--safe-area-inset-top))'
      },
      '@supports (padding-top: env(safe-area-inset-top))': {
        '--safe-area-inset-top': 'env(safe-area-inset-top)',
        paddingTop: 'var(--safe-area-inset-top)',
        height: 'calc(108px + var(--safe-area-inset-top))'
      },
      [mediaQuery[0]]: {
        display: 'flex'
      }
    }
  }, jsx("div", {
    style: {
      width: 74,
      backgroundColor: '#EBF1F4',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 74
    }
  }, id > 0 && isPreviousStepValid && jsx(ArrowLeftIcon, {
    name: "arrow-left",
    css: {
      width: 28,
      height: 22.69,
      color: '#CE1625'
    },
    onClick: () => handlerBack()
  })), jsx("div", {
    style: {
      padding: '18px 18px 8px 8px'
    }
  }, jsx("h1", {
    style: {
      margin: 0,
      padding: 0,
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '15px',
      lineHeight: '18px',
      letterSpacing: '0.0454545em',
      color: '#0F7CB5',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitLineClamp: '2'
    }
  }, procedure), jsx("h2", {
    style: {
      margin: 0,
      padding: 0,
      textTransform: 'uppercase',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '19px',
      letterSpacing: '0.0454545em',
      color: '#0D1F2D',
      marginBottom: 6
    }
  }, name), jsx("span", {
    style: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '19px',
      letterSpacing: '0.0454545em',
      color: '#0D1F2D'
    }
  }, "Paso: ", id + 1, "/", steps.length)), showLanguageSelector && jsx("div", {
    style: {
      position: 'absolute',
      top: 43,
      right: 10,
      zIndex: 100
    }
  }, jsx(LanguageSelectorVertical, {
    chevronColor: "#0d1f2d"
  })));
}
/**
 * This component represents the steps of the sidebar.
 * @param {JSON} containerStyle Custom style for the container.
 * @param {*} children Steps of the sidebar.
 * @param {*} alternativeControl Other step for the side bar container.
 * @param {JSON} listItemStyle Used to display the language selector.
 * @param {string} title  StepsSideBarHead title.
 * @param {string} subtitle StepsSideBarHead subtitle.
 * @param {string} name Mobile navigation header name.
 * @param {boolean} showLanguageSelector Used to display the language selector.
 */


const StepsSideBar = /*#__PURE__*/React.memo(({
  containerStyle,
  children,
  alternativeControl,
  listItemStyle,
  title,
  subtitle,
  name,
  showLanguageSelector = false
}) => {
  const {
    steps,
    currentPercentage,
    onGo
  } = useWizard();
  const {
    isMobile
  } = useMediaQuery();
  return jsx(React.Fragment, null, jsx(StepsSideBarContainer, {
    containerStyle: containerStyle
  }, jsx("div", {
    style: {
      paddingLeft: 30,
      paddingBottom: 15
    }
  }, children, jsx(StepsSideBarHead, {
    title: title,
    subtitle: subtitle
  }), jsx(StepsSideBarList, {
    listItemStyle: listItemStyle,
    state: {
      steps,
      currentPercentage,
      onGo
    }
  })), alternativeControl), isMobile ? jsx(MobileNavigationHeader, {
    name: name,
    showLanguageSelector: showLanguageSelector
  }) : null);
});
/**
 * This component represent.
 * @param {*} children Step content.
 * @param {string} code Step code
 */

function StepComponent({
  children,
  code
}) {
  const {
    steps
  } = useWizard();
  const i = steps.findIndex(({
    code: stepCode,
    status
  }) => stepCode === code && (status === 'current' || status === 'beforeFinished'));

  if (i < 0) {
    return null;
  }

  return jsx("div", {
    css: {
      padding: 4,
      [mediaQuery[0]]: {
        padding: 0
      }
    }
  }, children);
}

StepComponent.displayName = 'Step';
/**
 * This component represent the steps of the sidebar.
 * @param {*} children Step content.
 * @param {JSON} scrollStyle Custom scroll style for the wizard steps.
 */

function StepsContent({
  children,
  scrollStyle
}) {
  const {
    currentStepCode
  } = useWizard();
  const scrollBarRef = React.useRef();
  const {
    isMobile
  } = useMediaQuery();
  React.useEffect(() => {
    if (!isMobile) {
      if (scrollBarRef.current) {
        scrollBarRef.current.scrollToTop();
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [currentStepCode, isMobile]);
  return React.useMemo(() => {
    if (isMobile) {
      return jsx("div", {
        key: "content",
        className: "steps-content",
        name: "steps-content"
      }, children);
    }

    return jsx("div", {
      key: "content",
      className: "steps-content",
      name: "steps-content"
    }, jsx(ScrollBar, {
      ref: scrollBarRef,
      style: {
        width: '100%',
        height: '100%',
        minHeight: 'calc(100vh - 164px)',
        padding: 2,
        boxSizing: 'border-box',
        ...scrollStyle
      },
      scrollTop: 0,
      trackYProps: {
        renderer: props => {
          const {
            elementRef,
            style,
            ...restProps
          } = props;
          return jsx("span", _extends({}, restProps, {
            style: { ...style,
              backgroundColor: '#e9f1f2'
            },
            ref: elementRef
          }));
        }
      },
      thumbYProps: {
        renderer: props => {
          const {
            elementRef,
            ...restProps
          } = props;
          return jsx("div", _extends({}, restProps, {
            style: {
              backgroundColor: '#0883A0'
            },
            ref: elementRef
          }));
        }
      }
    }, children));
  }, [currentStepCode]);
}

StepsContent.displayName = 'StepsContent';
/**
 * This component represent the next button on wizard.
 * @param {*} children Button content.
 * @param {function} onClick Triggered when click o next button.
 * @param {*} props All other supported props.
 */

function StepButtonNext({
  children,
  onClick,
  ...props
}) {
  const {
    steps,
    currentIndex,
    dispatch
  } = useWizard();
  const disabled = steps.length === currentIndex + 1;
  return jsx(Button, _extends({
    color: "fireEngineRed",
    outline: true
  }, props, {
    onClick: () => dispatch({
      type: 'next'
    }),
    disabled: disabled
  }), children);
}
/**
 * This component represent the back button on wizard.
 * @param {*} children Button content.
 * @param {function} onClick Triggered when click o back button.
 * @param {*} props All other supported props.
 */


function StepButtonBack({
  children,
  onClick,
  ...props
}) {
  const {
    currentIndex,
    dispatch
  } = useWizard();
  const disabled = currentIndex === 0;
  return jsx(Button, _extends({
    outline: true
  }, props, {
    onClick: () => dispatch({
      type: 'back'
    }),
    disabled: disabled
  }), children);
}
/**
 * This component represents the wizard provider.
 * @param {*} children Wizard content.
 * @param {number} currentStep Current wizard step, default 0.
 * @param {function} currentStepByCode Current step by code on the wizard.
 * @param {JSON} containerStyle Custom container style for the wizard.
 * @param {JSON} css Custom style for provider.
 * @param {string} language Used to change the language.
 * @param {*} props All other supported props.
 */


function WizardProvider({
  children,
  currentStep = 0,
  currentStepByCode = '',
  containerStyle,
  css,
  language,
  ...props
}) {
  const [memoizedSteps, currentStepIndex] = React.useMemo(() => {
    let currentIndex = currentStep;
    const [steps] = React.Children.toArray(children).filter(child => child.type.displayName === 'StepsContent').map(child => {
      return React.Children.toArray(child.props.children).filter(({
        type
      }) => type.type.displayName === 'Step').map((step, index) => {
        var _step$props;

        if (((_step$props = step.props) === null || _step$props === void 0 ? void 0 : _step$props.code) === currentStepByCode) {
          currentIndex = index;
        }

        return step;
      }).map((step, index) => {
        var _step$props$valid, _step$props2, _step$props$code, _step$props3;

        let status = 'inactive';

        if (index === currentIndex) {
          status = 'current';
        } else if (index < currentIndex) {
          status = 'finished';
        }

        const valid = (_step$props$valid = (_step$props2 = step.props) === null || _step$props2 === void 0 ? void 0 : _step$props2.valid) !== null && _step$props$valid !== void 0 ? _step$props$valid : status === 'finished';
        return {
          id: index,
          order: index,
          code: (_step$props$code = (_step$props3 = step.props) === null || _step$props3 === void 0 ? void 0 : _step$props3.code) !== null && _step$props$code !== void 0 ? _step$props$code : null,
          name: step.props.name,
          status,
          valid
        };
      });
    });
    return [steps, currentIndex];
  }, []);
  const [state, dispatch] = React.useReducer(reducer, {
    currentIndex: currentStepIndex,
    currentStepCode: memoizedSteps[currentStepIndex].code,
    currentPercentage: currentStepIndex * (100 / (memoizedSteps.length - 1)),
    percentageToIncrease: 100 / (memoizedSteps.length - 1),
    steps: memoizedSteps,
    action: 'initialize',
    status: 'initial',
    isNexButtonDisabled: false,
    isSaveAndExitModalVisible: false,
    onNextClick: () => {},
    onBackClick: () => {},
    onGo: () => {},
    onCloseClick: () => {}
  });
  const componentDidMount = React.useRef(false);
  React.useLayoutEffect(() => {
    if (componentDidMount.current) {
      const steps = [...state.steps];
      React.Children.toArray(children).filter(child => child.type.displayName === 'StepsContent').map(child => {
        return React.Children.toArray(child.props.children).filter(({
          type
        }) => type.type.displayName === 'Step').forEach(step => {
          const index = steps.findIndex(({
            code
          }) => code === step.props.code);
          steps[index] = { ...steps[index],
            name: step.props.name
          };
        });
      });
      dispatch({
        type: 'updateSteps',
        steps
      });
    } else {
      componentDidMount.current = true;
    }
  }, [language]);
  const onNext = React.useCallback(async () => {
    const promises = [];

    if (state.onNextClick) {
      promises.push(state.onNextClick);
    }

    async function onNextLocal() {
      dispatch({
        type: 'next'
      });
    }

    promises.push(onNextLocal);

    try {
      for (let index = 0; index < promises.length; index++) {
        const promise = promises[index]; // se puede hacer promise.all y evitar esta regla
        // pero aqui lo ocupa en paralelo
        // eslint-disable-next-line no-await-in-loop

        await promise();
      }
    } catch (error) {
      console.error(error);
    }
  }, [state.onNextClick]);
  const onBack = React.useCallback(async () => {
    const promises = [];

    if (state.onBackClick) {
      promises.push(state.onBackClick);
    }

    async function onBackLocal() {
      dispatch({
        type: 'back'
      });
    }

    promises.push(onBackLocal);

    try {
      for (let index = 0; index < promises.length; index++) {
        const promise = promises[index]; // se puede hacer promise.all y evitar esta regla
        // pero aqui lo ocupa en paralelo
        // eslint-disable-next-line no-await-in-loop

        await promise();
      }
    } catch (error) {
      console.error(error);
    }
  }, [state.onBackClick]);
  const onGo = React.useCallback(async stepId => {
    const promises = [];

    if (state.onGo) {
      promises.push(state.onGo);
    }

    async function onGoLocal() {
      dispatch({
        type: 'go',
        index: stepId
      });
    }

    promises.push(onGoLocal);

    try {
      for (let index = 0; index < promises.length; index++) {
        const promise = promises[index]; // se puede hacer promise.all y evitar esta regla
        // pero aqui lo ocupa en paralelo
        // eslint-disable-next-line no-await-in-loop

        await promise();
      }
    } catch (error) {
      console.error(error);
    }
  }, [state.onGo]);
  const onClose = React.useCallback(async () => {
    const promises = [];

    if (state.onCloseClick) {
      promises.push(state.onCloseClick);
    }

    async function onCloseClickLocal() {
      dispatch({
        type: 'close'
      });
    }

    promises.push(onCloseClickLocal);

    try {
      for (let index = 0; index < promises.length; index++) {
        const promise = promises[index]; // se puede hacer promise.all y evitar esta regla
        // pero aqui lo ocupa en paralelo
        // eslint-disable-next-line no-await-in-loop

        await promise();
      }
    } catch (error) {
      console.error(error);
    }
  }, [state.onCloseClick]);
  const value = React.useMemo(() => ({ ...state,
    dispatch,
    onNext,
    onBack,
    onGo,
    onClose
  }), [state, dispatch, onNext, onBack, onGo, onClose]);
  return jsx(WizardContext.Provider, {
    value: value
  }, jsx("div", _extends({
    css: styles,
    style: { ...containerStyle
    }
  }, props), children));
}

const Step = /*#__PURE__*/React.memo(StepComponent);
export { WizardProvider, useWizard, useWizardMainNavigation, Step, StepButtonNext, StepButtonBack, StepsSideBar, StepsContent };